import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// ---------------------------------------------------------------------------
// Async thunk
// ---------------------------------------------------------------------------
export const fetchUsersData = createAsyncThunk(
  'users/fetchUsers',
  async (_, { rejectWithValue }) => {
    return rejectWithValue('Users API unavailable');
  }
);

// ---------------------------------------------------------------------------
// Slice
// ---------------------------------------------------------------------------
const usersSlice = createSlice({
  name: 'users',
  initialState: {
    items: [],
    /** 'idle' | 'loading' | 'succeeded' | 'failed' */
    status: 'idle',
    error: null,
    lastFetchedAt: null,
  },
  reducers: {
    /**
     * Mark the list as stale so the next mount triggers a fresh API call.
     * Call this before re-dispatching fetchUsersData after a mutation.
     */
    invalidateUsers: (state) => {
      state.status = 'idle';
      state.lastFetchedAt = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersData.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchUsersData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload || [];
        state.lastFetchedAt = Date.now();
        state.error = null;
      })
      .addCase(fetchUsersData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch users';
      });
  },
});

export const { invalidateUsers } = usersSlice.actions;
export default usersSlice.reducer;
